import { spacing } from './spacing'

export interface ComponentStyles {
  integratedBenefitsExplorer: {
    showHeader: boolean
    showMinimizedBannerDesign: boolean
    showBenefitsAndCoverageSection: boolean
    showEmbeddedFeaturedToolkit: boolean
  }
  integratedBenefitsEntryCard: {
    showBorder: boolean
    paddingHorizontal: string
    divider: {
      height: string
    }
    shouldShowArrow: boolean
    allowBackgroundColorOverride: boolean
    showEmbeddedFeaturedToolkit: boolean
  }
  compactImageCard: {
    useBodyText: boolean
    shouldShowChevron: boolean
    borderRadius: string
    showBorder: boolean
  }
  navBar: {
    useSmallBackButton: boolean
    showBottomBorder: boolean
  }
  inputField: {
    enableAiBorder: boolean
    default: {
      borderRadius: number
      borderWidth: number
      paddingHorizontal: number
      paddingVertical: number
    }
    active: {
      borderWidth: number
      paddingHorizontal?: number
      paddingVertical?: number
    }
  }
  useFloatingCardsShadows: boolean
  forkedTriage: {
    showCareOptionIllustration: boolean
    useBoldTitleForMainCareOption: boolean
    mainCareOptionCardCustomStyle?: { border: string }
  }
  illustrationBadge: {
    showBorder: boolean
  }
}

export const defaultComponentStyles: ComponentStyles = {
  integratedBenefitsExplorer: {
    showHeader: false,
    showMinimizedBannerDesign: true,
    showBenefitsAndCoverageSection: false,
    showEmbeddedFeaturedToolkit: true,
  },
  integratedBenefitsEntryCard: {
    showBorder: true,
    paddingHorizontal: spacing['24px'],
    divider: {
      height: '2px',
    },
    shouldShowArrow: true,
    allowBackgroundColorOverride: true,
    showEmbeddedFeaturedToolkit: true,
  },
  compactImageCard: {
    useBodyText: true,
    shouldShowChevron: true,
    borderRadius: spacing['16px'],
    showBorder: true,
  },
  navBar: {
    useSmallBackButton: true,
    showBottomBorder: true,
  },
  inputField: {
    enableAiBorder: true,
    default: {
      borderRadius: 8,
      borderWidth: 1,
      paddingHorizontal: 15,
      paddingVertical: 11,
    },
    active: {
      borderWidth: 2,
      paddingHorizontal: 14,
      paddingVertical: 10,
    },
  },
  useFloatingCardsShadows: true,
  forkedTriage: {
    showCareOptionIllustration: true,
    useBoldTitleForMainCareOption: true,
  },
  illustrationBadge: {
    showBorder: true,
  },
}
